import router from '@/router';
import { Channel } from '@/libraries/channel.ts';
import store from '@/store';

const channel = Channel.getInstance('ally');

export default {
	async setCurUrl({ commit }: any): Promise<any> {
		const response = await channel.emit({
			command: 'curURL',
			to: 'background',
		});

		commit('SET_CUR_URL', response);
	},
	async urlChanged({ dispatch, state }: any): Promise<any> {
		const newURL = await channel.emit({
			command: 'curURL',
			to: 'background',
		});

		return (newURL === state.curURL);
	},
	async doneLoading(): Promise<any> {
		const response = await channel.emit({
			command: 'doneLoading',
			to: 'background',
		});
	},
	focusOnInput(): void {
		setTimeout(() => {
			if (window.document.getElementById('ally-input-field') !== null &&
				// @ts-ignore
				!window.document.getElementById('ally-input-field').disabled) {
				// @ts-ignore
				window.document.getElementById('ally-input-field').focus();
			}
		}, 50);
	},
	focusOnLoginButton(): void {
		setTimeout(() => {
			if (window.document.getElementById('login-button') !== null) {
				// @ts-ignore
				window.document.getElementById('login-button').focus();
			}
		}, 50);
	},
	clickEditButton(): void {
		setTimeout(() => {
			if (window.document.getElementById('edit-button') !== null) {
				// @ts-ignore
				window.document.getElementById('edit-button').focus();
				window.document.getElementById('edit-button').click();
			}
		}, 50);
	},
	async getGK({ dispatch, commit, state }: any): Promise<any> {
		const response = await channel.emit({
			command: 'getGK',
			to: 'background',
		});

		commit('SET_GK', response);
	},
	handleNotLoggedIn({ commit, dispatch }: any, isLoggedIn: boolean) {
		commit('SET_AUTH_STATE', isLoggedIn);
		if (!isLoggedIn) {
			commit('CLEAR_GK');
			router.push('/login');
			window.requestAnimationFrame(() => {
				channel.emit({
					to: 'parent',
					command: 'update-ally-list-length',
					args: [ 0 ],
				});
				dispatch('focusOnLoginButton');
			});
		} else if (isLoggedIn && router.currentRoute.path === '/login') {
			router.push('/');
		}
	},
	async getState({ commit }: any): Promise<any> {
		const sets = await channel.emit({
			command: 'launch',
			to: 'background',
		});

		return sets;
	},
	async openAlly({ commit, dispatch, state }: any): Promise<any> {
		commit('OPEN_ALLY');

		dispatch('addNotification', 'To claim your spot (skip the waitlist), just email "New Extension" to kevin@tryinclude.ai 🎉');
		dispatch('addNotification', 'Ally will be replaced by a new simpler, faster, and more powerful replacement.');
		dispatch('addNotification', 'Thank you for being an early Beta User! We will be sunsetting Ally at the end of May 2020.');

		dispatch('resetAllyState');

		dispatch('isLoggedIn').then((isLoggedIn: boolean) => {
			dispatch('handleNotLoggedIn', isLoggedIn);
		});

		dispatch('getGK');
		dispatch('focusOnInput');
		const initState = await dispatch('getState');
		if (initState.success) {
			dispatch('setState', [initState.resp, true]); // does not clear input
			if (state.loggedIn) {
				if (store.getters.displayList[state.activeIdx] !== undefined) {
					channel.emit({
						to: 'background',
						command: 'updateActiveIdx',
						args: [ store.getters.displayList[state.activeIdx].id ],
					});
				}
			}
		}
	},
	closeAlly({ commit }: any): void {
		commit('CLOSE_ALLY');
		commit('RESET_ALLY_STATE');
		channel.emit({
			to: 'background',
			command: 'resetLauncher',
		});
	},
	closeAllyWithoutReset( { commit }: any): void {
		commit('CLOSE_ALLY');
		channel.emit({
			to: 'background',
			command: 'turnAllyIntoBubble',
		});
	},
	closeAllyWithoutReport({ commit }: any): void {
		commit('CLOSE_ALLY');
		commit('RESET_ALLY_STATE');
	},
	closeAllyFromAlly({ dispatch }: any) {
		channel.emit({
			to: 'parent',
			command: 'close-ally',
		});
		dispatch('closeAlly');
	},
	resetAllyState({ commit, dispatch }: any): void {
		commit('UPDATE_CRUMBS', []);
		commit('UPDATE_PLACEHOLDER', 'What do you want to do?');
		dispatch('setInputText', '');
		dispatch('resetAutoCompleteText');
	},
	async restartLauncher({ dispatch }: any) {
		const newState: any = await channel.emit({
			to: 'background',
			command: 'restartLauncher',
		});

		if (newState.success) {
			dispatch('setState', [newState.resp]);
		}
		dispatch('focusOnInput');
	},
	displayLauncherData({ commit }: any, data: any) {
		commit('SET_DATA_PANEL_DATA', data);
	},
	clearLauncherData({ commit }: any) {
		commit('RESET_DATA_PANEL_DATA');
	},
};
